import { render, staticRenderFns } from "./MicMenu.vue?vue&type=template&id=2e046e3a&scoped=true"
import script from "./MicMenu.vue?vue&type=script&lang=js"
export * from "./MicMenu.vue?vue&type=script&lang=js"
import style0 from "./MicMenu.vue?vue&type=style&index=0&id=2e046e3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e046e3a",
  null
  
)

export default component.exports